<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { throttle } from 'cfmoto-utils';
import router from '@/router/index';
import store from '@/store/index';
import envConfig from '@/config';
const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];

export default {
  el: '#app',
  store,
  router,
  data() {
    return { intervalLogout: 0 };
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  methods: {
    resetLogout() {
      clearTimeout(this.intervalLogout);
      this.intervalLogout = setTimeout(() => {
        this.$store.dispatch('user/logout');
        // if (this.$route.name === 'auth.user.login') return;
        window.location.href = `${baseURL}/riskcontrol/oauth/logout`;
      }, 1000 * 60 * 120);
    },
  },
  mounted() {
    this.refreshSession = throttle(1000 * 60 * 1, async () => {
      // if (this.$route.name === 'auth.user.login') return;
      await store.dispatch('refreshToken');
      this.resetLogout();
    });
    this.resetLogout();
    ['mousemove', 'scroll', 'keyup', 'click'].forEach((eventName) => {
      window.addEventListener(eventName, this.refreshSession);
    });
  },
  beforeDestroy() {
    clearInterval(this.intervalLogout);
    ['mousemove', 'scroll', 'keyup', 'click'].forEach((eventName) => {
      window.removeEventListener(eventName, this.refreshSession);
    });
  },
};
</script>
<style lang="less">
// @import './styles/app.less';
#app {
  height: 100%;
}
</style>
